import { useQuery, gql } from '@apollo/client';
import isString from 'lodash/isString';
import { CurrentRemoteRefreshTokenQuery } from '../graphql/__generated__/operations';
import { usePublicConfig } from '../providers';

const remoteRefreshTokenQuery = gql`
  query CurrentRemoteRefreshToken {
    currentRemoteRefreshToken {
      id
      token
    }
  }
`;

const prod = process.env.NODE_ENV === 'production';
const pollInterval = prod ? 10 * 60 * 1000 : 100 * 1000;
const notifyOnNetworkStatusChange = true;

export const RemoteRefreshTokenWatcher = (): null => {
  const { publicConfig } = usePublicConfig();
  const localToken = publicConfig.remoteRefreshToken?.token;

  const config = {
    pollInterval,
    notifyOnNetworkStatusChange,
    skip: !localToken,
  };
  const { data } = useQuery<CurrentRemoteRefreshTokenQuery>(
    remoteRefreshTokenQuery,
    config
  );

  const token = data?.currentRemoteRefreshToken?.token;
  if (isString(token) && isString(localToken) && token !== localToken) {
    window.location.reload();
  }
  return null;
};
